import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../tailwind.config";

const fullConfig = resolveConfig(tailwindConfig) as {
  theme: {
    colors?: {
      avatar?: Record<string, string>;
    };
  };
};

//* Dynamic theme color generator
export const generateRandomColor = (seed: string): string => {
  const hash = seed
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);

  const avatarColors = fullConfig.theme.colors?.avatar;
  if (!avatarColors) {
    throw new Error("Avatar colors are not defined in the theme.");
  }

  const colors = Object.values(avatarColors);
  return colors[hash % colors.length];
};
